import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './common/Header';
import Footer from './common/Footer';
import UserTypeToggle from './common/UserTypeToggle';
import HeroSection from './sections/HeroSection';
import ProblemStatement from './sections/ProblemStatement';
import SolutionOverview from './sections/SolutionOverview';
import BenefitsShowcase from './sections/BenefitsShowcase';
import SuccessStories from './sections/SuccessStories';
import PricingSection from './sections/PricingSection';
import FAQSection from './sections/FAQSection';
import RegistrationCTA from './sections/RegistrationCTA';

const LandingPage = () => {
  const [userType, setUserType] = useState('screen-owner');
  const [stats, setStats] = useState({
    activeScreens: 247,
    cities: 5,
    impressions: '100K+',
    revenue: '₹25M'
  });

  const navigate = useNavigate();

  // Update statistics in real-time
  useEffect(() => {
    const interval = setInterval(() => {
      setStats(prev => ({
        ...prev,
        activeScreens: prev.activeScreens + Math.floor(Math.random() * 3),
        revenue: `₹${(parseFloat(prev.revenue.replace('₹', '').replace('M', '')) + 0.1).toFixed(1)}M`
      }));
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const handleUserTypeChange = (type) => {
    setUserType(type);
  };

  const handleGetStarted = (type) => {
    if (type === 'screen-owner') {
      navigate('/register-screen');
    } else {
      navigate('/advertiser-dashboard');
    }
  };

  return (
    <div className="font-inter bg-background">
      <Header />
      
      <HeroSection 
        userType={userType}
        onUserTypeChange={handleUserTypeChange}
        onGetStarted={handleGetStarted}
        stats={stats}
      />
      
      <ProblemStatement />
      
      <SolutionOverview />
      
      <BenefitsShowcase />
      
      <SuccessStories stats={stats} />
      
      <PricingSection />
      
      <FAQSection />
      
      <RegistrationCTA onGetStarted={handleGetStarted} />
      
      <Footer />
    </div>
  );
};

export default LandingPage;